import { useMantineColorScheme } from "@mantine/core"
import dayjs from "dayjs"
import { useSystemColors } from "@components/use-system-colors"

export function useBackgroundColorForDate(date: Date, isHoliday?: boolean) {
  const { colorScheme } = useMantineColorScheme()

  const systemColors = useSystemColors()

  if (colorScheme === "dark") {
    return dayjs(date).isToday()
      ? systemColors.get("TodayBackColorDark")
      : isHoliday
        ? systemColors.get("HolidayBackColorDark")
        : date.getDay() === 6
          ? systemColors.get("SaturdayBackColorDark")
          : date.getDay() === 0
            ? systemColors.get("SundayBackColorDark")
            : undefined
  }

  return dayjs(date).isToday()
    ? systemColors.get("TodayBackColor")
    : isHoliday
      ? systemColors.get("Holiday")
      : date.getDay() === 6
        ? systemColors.get("Saturday")
        : date.getDay() === 0
          ? systemColors.get("Sunday")
          : undefined
}

export function useSchoolHolidayColor() {
  const { colorScheme } = useMantineColorScheme()

  const systemColors = useSystemColors()

  return colorScheme === "dark"
    ? systemColors.get("SchoolHolidaysBackColorDark")
    : systemColors.get("SchoolHolidaysBackColor")
}
